"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectT;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
require("./styles.scss");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconTooltip = _interopRequireDefault(require("../IconTooltip"));
var _utils = require("../../utils");
// Styles for overriding select dropdown

function SelectT(props) {
  const {
    className,
    disabled,
    displayLabel,
    editable,
    errorText,
    fixedMenu,
    fullWidth,
    helperText,
    hideArrow,
    id,
    isEqual,
    label,
    onBlur,
    onChange,
    onFocus,
    options,
    placeholder,
    readonly,
    renderOption,
    required,
    selectedValue,
    selectStyles,
    tooltipTitle,
    toT,
    warningText
  } = props;
  const selectClass = (0, _classnames.default)({
    'textfield-value': true,
    'textfield-value--disabled': disabled,
    'textfield-value--error': !!errorText,
    'textfield-value--warning': !!warningText,
    'textfield-value--readonly': readonly
  });
  const itemClass = (0, _classnames.default)({
    'select-value': true,
    'select-value--disabled': disabled
  });
  const [openedOptions, setOpenedOptions] = (0, _react.useState)(false);
  const [fixedMenuPositioned, setFixedMenuPositioned] = (0, _react.useState)(false);
  const [selectedIndex, setSelectedIndex] = (0, _react.useState)(-1);
  const inputRef = (0, _react.useRef)(null);
  const dropdownRef = (0, _react.useRef)(null);
  const hasOptions = (0, _react.useMemo)(() => options !== undefined && options.length > 0, [options]);
  const repositionMenu = (0, _react.useCallback)(checkHeight => {
    if (openedOptions && hasOptions) {
      scrollToSelectedElement();
      if (fixedMenu && inputRef.current && dropdownRef.current) {
        dropdownRef.current.style.width = "".concat(inputRef.current.offsetWidth, "px");
        const bbox = inputRef.current.getBoundingClientRect();
        dropdownRef.current.style.top = "".concat(bbox.top + bbox.height, "px");
        const dropdownBottom = dropdownRef.current.clientHeight + bbox.top + bbox.height;
        const windowHeightThreshold = window.innerHeight - bbox.height;
        if (checkHeight && dropdownBottom > windowHeightThreshold) {
          dropdownRef.current.style.maxHeight = "".concat(dropdownRef.current.clientHeight - (dropdownBottom - windowHeightThreshold), "px");
        }
        setFixedMenuPositioned(true);
      }
    } else if (fixedMenu) {
      setFixedMenuPositioned(false);
    }
  }, [fixedMenu, openedOptions, hasOptions]);
  (0, _react.useEffect)(() => {
    repositionMenu(true);
  }, [repositionMenu]);
  (0, _react.useEffect)(() => {
    let newIndex = -1;
    if (options && selectedValue) {
      options.find((option, index) => {
        if (isEqual(option, selectedValue)) {
          newIndex = index;
          return true;
        }
        return false;
      });
    }
    if (newIndex !== selectedIndex) {
      setSelectedIndex(newIndex);
    }
  }, [options, selectedValue, selectedIndex, isEqual]);
  const handleScroll = (0, _react.useCallback)(() => {
    repositionMenu(false);
  }, [repositionMenu]);
  const handleClick = (0, _react.useCallback)(event => {
    // Don't respond to user clicks inside the input box because those are
    // already handled by toggleOptions()
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
      setOpenedOptions(false);
    }
  }, []);
  const handleResize = (0, _react.useCallback)(() => {
    setOpenedOptions(false);
  }, []);
  (0, _react.useEffect)(() => {
    window.addEventListener('click', handleClick);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleClick, handleResize, handleScroll]);
  const toggleOptions = () => {
    setOpenedOptions(isOpen => !isOpen);
  };
  const onOptionSelected = (option, index) => {
    if (onChange) {
      onChange(option);
    }
    setOpenedOptions(false);
    setSelectedIndex(index);
  };
  const onChangeHandler = e => {
    const textValue = e.target.value;
    if ((0, _utils.isWhitespaces)(textValue)) {
      return;
    }
    if (onChange) {
      onChange(toT(textValue));
    }
    setOpenedOptions(true);
  };
  const onKeyDownHandler = e => {
    var _dropdownRef$current;
    const pressedLetter = e.key.toUpperCase();
    const items = (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.getElementsByTagName('li');
    if (items) {
      const arrayOfItems = Array.from(items);
      for (const item of arrayOfItems) {
        if (item.dataset.key === pressedLetter) {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          return;
        }
      }
    }
  };
  const scrollToSelectedElement = () => {
    var _dropdownRef$current2;
    const items = (_dropdownRef$current2 = dropdownRef.current) === null || _dropdownRef$current2 === void 0 ? void 0 : _dropdownRef$current2.getElementsByTagName('li');
    if (items) {
      const arrayOfItems = Array.from(items);
      for (const item of arrayOfItems) {
        if (item.dataset.selected === 'true') {
          if (dropdownRef.current) {
            const topPos = item.offsetTop;
            dropdownRef.current.scrollTop = topPos;
            return;
          }
        }
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "select ".concat(className)
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-label"
  }, label, " ", required ? '*' : '', " ", tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    title: tooltipTitle
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-container ".concat(fullWidth ? 'textfield-container--fullWidth' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: selectClass,
    onClick: toggleOptions,
    ref: inputRef,
    style: (selectStyles || {}).inputContainer
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: displayLabel(selectedValue),
    readOnly: !editable || readonly,
    placeholder: placeholder,
    onChange: onChangeHandler,
    onKeyDown: onKeyDownHandler,
    onBlur: onBlur,
    onFocus: onFocus,
    required: required,
    style: (selectStyles || {}).input
  }), !hideArrow && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: 'chevronDown',
    className: "textfield-value--icon-right",
    style: (selectStyles || {}).arrow
  })), options && options.length > 0 && openedOptions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fixedMenu && /*#__PURE__*/_react.default.createElement("div", {
    className: "scroll-block"
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: 'options-container' + (fixedMenu ? ' fixed-menu' : '') + (fixedMenuPositioned ? ' positioned' : ''),
    ref: dropdownRef,
    style: (selectStyles || {}).optionsContainer
  }, options.map((option, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-key": displayLabel(option).charAt(0).toUpperCase(),
      "data-selected": selectedIndex === index,
      key: index,
      onClick: () => !readonly ? onOptionSelected(option, index) : undefined,
      className: "".concat(itemClass, " ").concat(selectedIndex === index ? 'select-value--selected' : '', " "),
      style: (selectStyles || {}).optionContainer
    }, renderOption(option));
  })))), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-label-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "textfield-error-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-error-text"
  }, errorText)), warningText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-label-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "warning",
    className: "textfield-warning-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-warning-text"
  }, warningText)), helperText && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-help-text"
  }, helperText));
}